import { useState } from "react";
import apiService from "../../Services/apiService";
import Title from "./Title";
import { readExcelFile } from "../../Services/excelApi";
import Loading from '../General/Loading';
import excelSampelImg from '../../assets/images/branchesSampel.png';
import excelSampelFile from '../../assets/excelSampels/branches_sampel.xlsx';
type Branch = {
  branchName: string;
  branchCode: string;
  portCode: string;
  portName: string;
  address: string;
  contactPerson: string;
  city: string;
  area: string;
  mobile: string;
  latitude: string;
  longitude: string;
  telephone: string;
  fax: string;
  email: string;
  status: string;
};

type RowValidation = {
  valid: boolean;
  errors: string[];
};

const emptyValidation = (): RowValidation => ({
  valid: false,
  errors: [],
});

const UpdateBranchesExcel = () => {
  const [loading, setLoading] = useState(false);

  // Excel data
  const [branches, setBranches] = useState<Branch[]>([]);

  // Validation result for every row
  const [validationResults, setValidationResults] = useState<RowValidation[]>(
    [],
  );

  // Global error
  const [error, setError] = useState<string | null>(null);
 const [success, setSuccess] = useState<string | null>(null);
  // Has the user clicked Analysis?
  const [isAnalyzed, setIsAnalyzed] = useState(false);

  // ---------------------------------------------------------
  // Read Excel file
  // ---------------------------------------------------------
  const handleFileChangeNew = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const selectedFile = event.target.files?.[0];

    if (!selectedFile) {
      return;
    }

    setLoading(true);
    setError(null);

    // Reset previous analysis
    setBranches([]);
    setValidationResults([]);
    setIsAnalyzed(false);

    try {
      console.log("Selected file:", selectedFile.name);

      const result = await readExcelFile(selectedFile);

      if (!result?.sheets?.[0]?.rows) {
        throw new Error("Excel file does not contain any rows.");
      }

      /*
       * Excel columns:
       *
       * 0  BranchName
       * 1  BranchCode
       * 2  PortCode
       * 3  PortName
       * 4  Address
       * 5  ContactPerson
       * 6  City
       * 7  Area
       * 8  Mobile
       * 9  Latitude
       * 10 Longitude
       * 11 Telephone
       * 12 Fax
       * 13 Email
       * 14 Status
       *
       * slice(1) removes the first/header row.
       */

      const rows: Branch[] = result.sheets[0].rows
        .slice(1)
        .map((row) => ({
          branchName: String(row[0] ?? "").trim(),
          branchCode: String(row[1] ?? "").trim(),
          portCode: String(row[2] ?? "").trim(),
          portName: String(row[3] ?? "").trim(),
          address: String(row[4] ?? "").trim(),
          contactPerson: String(row[5] ?? "").trim(),
          city: String(row[6] ?? "").trim(),
          area: String(row[7] ?? "").trim(),
          mobile: String(row[8] ?? "").trim(),
          latitude: String(row[9] ?? "").trim(),
          longitude: String(row[10] ?? "").trim(),
          telephone: String(row[11] ?? "").trim(),
          fax: String(row[12] ?? "").trim(),
          email: String(row[13] ?? "").trim(),
          status: String(row[14] ?? "").trim(),
        }));

      console.log("Excel rows:", rows);
      console.log("Number of rows:", rows.length);

      setBranches(rows);

      // Create validation placeholders
      setValidationResults(rows.map(() => emptyValidation()));
    } catch (err) {
      console.error("Failed to read Excel file:", err);

      setError(
        err instanceof Error
          ? err.message
          : "Failed to read Excel file.",
      );

      setBranches([]);
      setValidationResults([]);
      setIsAnalyzed(false);
    } finally {
      setLoading(false);

      // Allow selecting the same file again
      event.target.value = "";
    }
  };

  // ---------------------------------------------------------
  // Validate one row
  // ---------------------------------------------------------
 const validateBranch = (branch: Branch): string[] => {
  const errors: string[] = [];

  // BranchName: required
  if (!branch.branchName) {
    errors.push("اسم الفرع إجباري");
  }

  // BranchCode: required + digits only
  if (!branch.branchCode) {
    errors.push("رقم الفرع اجباري");
  } else if (!/^\d+$/.test(branch.branchCode)) {
    errors.push("الفرع يجب ان يكون رقم");
  }

  // PortCode: required + digits only
  if (!branch.portCode) {
    errors.push("رقم المتجر اجباري");
  } else if (!/^\d+$/.test(branch.portCode)) {
    errors.push("رقم المتجر رقمي");
  }

  // PortName: required
  if (!branch.portName) {
    errors.push("اسم الفرع اجباري");
  }

  // City: required
  if (!branch.city) {
    errors.push("المدينة اجباري");
  }

  // Area: required
  if (!branch.area) {
 errors.push("المدينة المنطقة");
  }

  // =====================================================
  // Latitude
  // =====================================================

  if (!branch.latitude) {
   errors.push("خط الطول اجباري");
  } else {
    const latitude = Number(branch.latitude);

    if (Number.isNaN(latitude)) {
      errors.push(
        "صيغة خط الطول غير صحيح, e.g. 21.3891."
      );
    } else if (latitude < -90 || latitude > 90) {
      errors.push(
        "خط الطول يجب بين -90 و 90."
      );
    }
  }

  // =====================================================
  // Longitude
  // =====================================================

  if (!branch.longitude) {
     errors.push("خط العرض اجباري");
  } else {
    const longitude = Number(branch.longitude);

    if (Number.isNaN(longitude)) {
      errors.push(
        "صيغة خط العرض غير صحيح, e.g. 39.8579."
      );
    } else if (longitude < -180 || longitude > 180) {
      errors.push(
        "خط العرض يجب بين -180 و 180."
      );
    }
  }

  return errors;
};

  // ---------------------------------------------------------
  // Analyze Excel
  // ---------------------------------------------------------
  const analyzeExcel = () => {
    if (branches.length === 0) {
      setError("يجب اختيار ملف الاكسل اولا");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const results: RowValidation[] = branches.map((branch) => {
        const errors = validateBranch(branch);

        return {
          valid: errors.length === 0,
          errors,
        };
      });

      setValidationResults(results);
      setIsAnalyzed(true);

      const invalidRows = results.filter((result) => !result.valid).length;

      if (invalidRows > 0) {
        setError(
          `${invalidRows} صف يحتوي على اخطاء ,,يجب معالجة الاخطاء اولا`,
        );
      } else {
        setError(null);
      }

      console.log("Validation results:", results);
    } catch (err) {
      console.error("Analysis error:", err);

      setError(
        err instanceof Error
          ? err.message
          : "Failed to analyze Excel file.",
      );
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------
  // Check if everything is valid
  // ---------------------------------------------------------
  const allRowsValid =
    branches.length > 0 &&
    isAnalyzed &&
    validationResults.length === branches.length &&
    validationResults.every((result) => result.valid);

  // ---------------------------------------------------------
  // Upload data
  // ---------------------------------------------------------
  const uploadData = async (): Promise<void> => {
    console.log("🔥 Upload clicked");
    console.log("Branches:", branches);

    if (branches.length === 0) {
      setError("Please select an Excel file first.");
      return;
    }

    if (!isAnalyzed) {
      setError("يجب تحليل ملف الإكسل اولا");
      return;
    }

    if (!allRowsValid) {
      setError("لايمكنك تحميل الملف,,يجب معالجة الاخطاء اولا");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const requestBody = {
        data: branches,
      };

      console.log(
        "📤 Sending:",
        JSON.stringify(requestBody, null, 2),
      );

      const result = await apiService.fetchData(
        "api/ImportExcelFile",
        requestBody,
      );
      if(result.isOk)
         setSuccess("✅ تم تحميل البيانات بنجاح");
        else
      {
         setError("لايمكنك تحميل الملف,,يجب معالجة الاخطاء اولا"); 
      }
      console.log("✅ API response:", result);
    } catch (err) {
      console.error("❌ Upload error:", err);

      setError(
        err instanceof Error
          ? err.message
          : "Failed to upload data.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
           <Loading />
      )}
      <main className="relative pt-16 min-h-screen bg-surface">
        <div className="flex flex-col w-full h-full p-margin-desktop gap-gutter max-w-[1200px] mx-auto">

          <Title
            pageName="تحديث فروع المتاجر"
            pageDesc="تحديث فروع المتاجر عبر ملف اكسل"
            isSearch={false}
          />

          {/* =====================================================
              Excel Upload
          ===================================================== */}
          <div className="bg-surface-container-lowest rounded-xl shadow-sm p-6 mb-6 border border-surface-variant/50">
            <div className="flex flex-col md:flex-row items-center gap-6">

              <div className="flex-1 w-full">
                <label
                  htmlFor="file-upload-input"
                  className="border-2 border-dashed border-outline-variant rounded-xl p-8 flex flex-col items-center justify-center gap-3 hover:border-vibrant-orange hover:bg-surface-container-low transition-all cursor-pointer group"
                >
                  <span className="material-symbols-outlined text-4xl text-on-surface-variant group-hover:text-vibrant-orange transition-colors">
                    upload_file
                  </span>

                  <div className="text-center">
                    <p className="font-label-md text-on-surface">
                      اسحب وأفلت ملف Excel هنا أو انقر للتحميل
                    </p>

                    <p className="font-body-sm text-on-surface-variant mt-1">
                      يدعم ملفات .xlsx و .xls فقط
                    </p>
                  </div>

                  <input
                    id="file-upload-input"
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={handleFileChangeNew}
                    className="hidden"
                  />
                </label>
              </div>

              {/* Template */}
              <div className="flex flex-col gap-4 min-w-[300px]">
                <div className="flex items-center justify-between">
                  <span className="font-label-md text-on-surface">
                    نموذج البيانات
                  </span>

                  <a 
                    className="flex items-center gap-1 text-primary hover:text-vibrant-orange transition-colors font-label-sm"
                    href={excelSampelFile}
  download="branchesSample.xlsx"
                  >
                    <span className="material-symbols-outlined text-lg">
                      download
                    </span>

                    <span>تحميل النموذج</span>
                  </a>
                </div>

                <div className="relative rounded-lg overflow-hidden border border-surface-variant/50 group">
                  <img
                    alt="Data Sample"
                    className="w-80 h-32 object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                    src={excelSampelImg}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
              Global Error
          ===================================================== */}
          {error && (
            <div className="bg-red-100 text-red-700 p-4 rounded-lg">
              {error}
            </div>
          )}
  {success && (
            <div className="bg-green-100 text-green-700 p-4 rounded-lg">
              {success}
            </div>
          )}
          {/* =====================================================
              Buttons
          ===================================================== */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-margin-mobile mb-margin-desktop">
            <div className="flex flex-col sm:flex-row gap-unit w-full md:w-auto">

              {/* Analyze */}
              <button
                type="button"
                onClick={analyzeExcel}
                disabled={loading || branches.length === 0}
                className="bg-surface-container hover:bg-surface-container-high disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-on-surface font-label-md text-label-md px-4 py-2 rounded-full flex items-center justify-center gap-2"
              >
                <span className="material-symbols-outlined text-lg">
                  filter_list
                </span>

                <span>
                  {loading ? "جاري التحليل..." : "تحليل البيانات"}
                </span>
              </button>

              {/* Upload */}
              <button
                type="button"
                onClick={uploadData}
                disabled={loading || !allRowsValid}
                className="bg-vibrant-orange hover:bg-secondary-container disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-on-primary font-label-md text-label-md px-6 py-2 rounded-full flex items-center justify-center gap-2 shadow-md"
              >
                <span className="material-symbols-outlined text-lg">
                  add
                </span>

                <span>
                  {loading
                    ? "جاري التحميل..."
                    : "تحميل البيانات"}
                </span>
              </button>

            </div>

            {/* Analysis status */}
            {isAnalyzed && (
              <div className="mt-3 md:mt-0">
                {allRowsValid ? (
                  <span className="text-green-600 font-label-sm">
                    ✓ جميع البيانات صحيحة
                  </span>
                ) : (
                  <span className="text-red-600 font-label-sm">
                    ✕ يوجد أخطاء في البيانات
                  </span>
                )}
              </div>
            )}
          </div>

          {/* =====================================================
              Data Table
          ===================================================== */}
          <div className="bg-surface-container-lowest rounded-xl shadow-sm overflow-hidden flex flex-col w-full">

            <div className="overflow-x-auto w-full">

              <table className="w-full text-right border-collapse">

                <thead className="bg-surface-container-low">
                  <tr>
                    <th className="px-6 py-4">الفرع</th>
                    <th className="px-6 py-4">المتجر</th>
                    <th className="px-6 py-4">العنوان</th>
                    <th className="px-6 py-4">ممثل الفرع</th>
                    <th className="px-6 py-4">المدينة-المنطقة</th>
                    <th className="px-6 py-4">رقم الهاتف</th>
                    <th className="px-6 py-4">خط الطول والعرض</th>
                    <th className="px-6 py-4">التحليل</th>
                  </tr>
                </thead>

                <tbody className="bg-surface-container-lowest">

                  {branches.map((row, rowIndex) => {
                    const validation = validationResults[rowIndex];

                    return (
                      <tr
                        key={rowIndex}
                        className={`transition-colors border-b ${
                          validation?.valid
                            ? "hover:bg-surface-muted border-surface-variant/50"
                            : "bg-red-50 border-red-200"
                        }`}
                      >

                        {/* Branch */}
                        <td
                          className="px-6 py-4 truncate max-w-[200px]"
                          dir="ltr"
                        >
                          {row.branchCode} - {row.branchName}
                        </td>

                        {/* Store */}
                        <td
                          className="px-6 py-4 truncate max-w-[200px]"
                          dir="ltr"
                        >
                          {row.portCode} - {row.portName}
                        </td>

                        {/* Address */}
                        <td
                          className="px-6 py-4 truncate max-w-[200px]"
                          dir="ltr"
                        >
                          {row.address}
                        </td>

                        {/* Contact Person */}
                        <td
                          className="px-6 py-4 truncate max-w-[200px]"
                          dir="ltr"
                        >
                          {row.contactPerson}
                        </td>

                        {/* City / Area */}
                        <td
                          className="px-6 py-4 truncate max-w-[200px]"
                          dir="ltr"
                        >
                          {row.city} - {row.area}
                        </td>

                        {/* Mobile */}
                        <td
                          className="px-6 py-4 truncate max-w-[200px]"
                          dir="ltr"
                        >
                          {row.mobile}
                        </td>

                        {/* Latitude / Longitude */}
                        <td
                          className="px-6 py-4 truncate max-w-[200px]"
                          dir="ltr"
                        >
                          {row.latitude} - {row.longitude}
                        </td>

                        {/* Validation */}
                        <td className="px-6 py-4 min-w-[250px]">

                          {!isAnalyzed ? (
                            <span className="text-gray-400">
                             لم يتم التحليل
                            </span>
                          ) : validation?.valid ? (
                            <div className="flex items-center gap-2 text-green-600">
                              <span className="material-symbols-outlined">
                                check_circle
                              </span>

                              <span>
                                نجاح
                              </span>
                            </div>
                          ) : (
                            <div className="text-red-600">

                              <div className="flex items-center gap-2 mb-2">
                                <span className="material-symbols-outlined">
                                  error
                                </span>

                                <span className="font-semibold">
                                  الاخطاء
                                </span>
                              </div>

                              <ul className="list-disc list-inside space-y-1 text-sm">
                                {validation?.errors.map(
                                  (validationError, errorIndex) => (
                                    <li key={errorIndex}>
                                      {validationError}
                                    </li>
                                  ),
                                )}
                              </ul>

                            </div>
                          )}

                        </td>

                      </tr>
                    );
                  })}

                </tbody>
              </table>
            </div>

            {/* =====================================================
                Pagination
            ===================================================== */}
            <div className="bg-surface-container-lowest px-6 py-4 flex items-center justify-between border-t border-surface-variant/50">

              <span className="font-body-sm text-body-sm text-on-surface-variant">
                عرض 1-{branches.length} من {branches.length} فرع
              </span>

              <div className="flex items-center gap-1">

                <button
                  type="button"
                  className="p-2 rounded-full text-on-surface-variant hover:bg-surface-container disabled:opacity-50 transition-colors"
                >
                  <span className="material-symbols-outlined text-sm">
                    chevron_right
                  </span>
                </button>

                <button
                  type="button"
                  className="w-8 h-8 rounded-full bg-primary-container text-primary flex items-center justify-center"
                >
                  1
                </button>

                <button
                  type="button"
                  className="w-8 h-8 rounded-full hover:bg-surface-container flex items-center justify-center"
                >
                  2
                </button>

                <button
                  type="button"
                  className="w-8 h-8 rounded-full hover:bg-surface-container flex items-center justify-center"
                >
                  3
                </button>

              </div>
            </div>

          </div>

        </div>
      </main>
    </>
  );
};

export default UpdateBranchesExcel;

